<template>
  <div v-if="story.related_stories" class="m-10">
    <div class="m-b-40">
      <el-form
        v-if="edit"
        @submit.native.prevent>
        <el-autocomplete
          v-model="storyTitle"
          :trigger-on-focus="false"
          :highlight-first-item="highlightFirstItem"
          :fetch-suggestions="storiesFilter"
          ref="autocomplete"
          prefix-icon="el-icon-search"
          placeholder="Ajouter un article"
          @keyup.enter.native=""
          @select="selectStory"></el-autocomplete>
      </el-form>
      <table class="table">
        <tbody v-if="story.related_stories.length == 0">
          <tr>
            <td colspan="4" class="text-center">
              <em class="text-muted">
                Pas d’article associé pour l'instant
              </em>
            </td>
          </tr>
        </tbody>
        <tbody>
          <tr v-for="story in story.related_stories">
            <td>
              <el-image
                style="width: 70px; height: 70px"
                :src="story.thumb_story_list_url"
                fit="contain"></el-image>
            </td>
            <td>
              <h5 class="m-b-10" :class="{'text-muted': !story.title}">
                {{ story.title || 'Aucun titre' }}
                <br>
                <small>
                  <span v-if="story.primary_category && story.primary_category.label">
                    <span>
                      <i class="fa fa-folder-o"></i>
                      {{ story.primary_category.label }}
                    </span>
                    - Publié le
                    {{ story.published_at | formatDate }}
                  </span>
                </small>
              </h5>
            </td>
            <td v-if="edit">
              <a href @click.prevent="deleteRelated(story.id)" class="btn btn-warning btn-sm">
                <i class="fa fa-trash"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <pre>{{ story.related_stories }}</pre> -->
    <!-- <pre>{{ story.contextual_stories }}</pre> -->
    <!-- <pre>{{ story.contextual_carousel }}</pre> -->
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'story-related',
  computed: mapGetters({
    constants: 'constants',
    story: 'story',
    storyPublicationRule: 'storyPublicationRule'
  }),
  components: {},
  props: {
    parentInitFunction: Function,
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dirty: false,
      storyTitle: null,
      highlightFirstItem: true,
      mask: 'id,related_stories{id,title,thumb_story_list_url,primary_category{label},created_at,published_at}'
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {},
    storiesFilter(queryString, cb) {
      let _this = this
      if (queryString) {
        this.axios.get('/stories/', {
          params: {
            term: queryString,
            scope: 'PUBLIC',
            per_page: 100},
          headers: {'x-fields': 'id,title'}
        }).then((response) => {
          var list = []
          response.data.results.map(function (value, key) {
            if (value.id !== _this.story.id) {
              list.push({value: `${value.title}`, id: value.id, story: value})
            }
          })
          cb(list)
        })
      }
    },
    selectStory(value) {
      if (value) {
        this.storyTitle = null
        this.$store.dispatch('addStoryRelated', {
          story_id: this.story.id,
          related_story_id: value.id,
          headers: {
            'X-Fields': this.mask
          }
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Article ajouté avec succes'
          })
        })
      }
    },
    deleteRelated (relatedStoryId) {
      this.$confirm('Supprimer l’association. Continuer ?', 'Warning', {
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('deleteStoryRelated', {
          story_id: this.story.id,
          related_story_id: relatedStoryId,
          headers: {
            'X-Fields': this.mask
          }
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Association supprimée'
          })
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Suppression annulée'
        })
      })
    }
  }
}
</script>
<style scoped>

.el-autocomplete {
  display: block;
}

</style>
